import ShopLayout from "./ShopLayout";

const COMPANY = "EMPRO Marcin Masny, ul. Targowa 60, 08-400 Garwolin, NIP 826-15-44-909";
const EMAIL = "biuro@empro.pro";

const DOCS = {
  regulamin: {
    title: "Regulamin sklepu internetowego",
    body: [
      ["§1. Postanowienia ogólne", [
        `Sklep internetowy działający pod adresem niniejszej strony prowadzony jest przez ${COMPANY} (dalej „Sprzedawca").`,
        "Regulamin określa zasady zawierania umów sprzedaży na odległość za pośrednictwem sklepu, prawa i obowiązki Sprzedawcy oraz Klienta.",
        `Kontakt ze Sprzedawcą: e-mail ${EMAIL}.`,
      ]],
      ["§2. Definicje", [
        "Klient — osoba fizyczna, osoba prawna lub jednostka organizacyjna dokonująca zakupów w sklepie.",
        "Konsument — Klient będący konsumentem w rozumieniu art. 22¹ Kodeksu cywilnego.",
        "Towar — produkt oferowany do sprzedaży w sklepie.",
      ]],
      ["§3. Składanie zamówień", [
        "Zamówienia można składać 24 godziny na dobę przez stronę sklepu.",
        "Warunkiem złożenia zamówienia jest podanie danych niezbędnych do realizacji oraz akceptacja niniejszego Regulaminu.",
        "Ceny towarów podane są w złotych polskich i zawierają podatek VAT (ceny brutto). Ceny nie zawierają kosztów dostawy, które wskazywane są w trakcie składania zamówienia.",
        "Zgodnie z dyrektywą Omnibus, w przypadku obniżki ceny obok ceny aktualnej prezentowana jest najniższa cena towaru z 30 dni poprzedzających obniżkę.",
      ]],
      ["§4. Płatności", [
        "Płatność realizowana jest online za pośrednictwem operatora płatności PayU S.A. (BLIK, karta płatnicza, szybki przelew).",
        "Umowa zostaje zawarta z chwilą potwierdzenia płatności.",
      ]],
      ["§5. Dostawa", [
        "Towary dostarczane są na terytorium Rzeczypospolitej Polskiej za pośrednictwem wybranego przez Klienta sposobu dostawy (paczkomat InPost, kurier) lub odbioru osobistego.",
        "Czas realizacji zamówienia podawany jest w opisie towaru lub w trakcie składania zamówienia. Wysyłka towaru następuje z siedziby Sprzedawcy.",
      ]],
      ["§6. Prawo odstąpienia od umowy", [
        "Konsument, który zawarł umowę na odległość, może w terminie 14 dni odstąpić od niej bez podawania przyczyny, na zasadach opisanych w zakładce „Prawo odstąpienia od umowy”.",
        "Prawo odstąpienia nie przysługuje w odniesieniu do towarów wyprodukowanych według specyfikacji Konsumenta lub służących zaspokojeniu jego zindywidualizowanych potrzeb (np. odzież z indywidualnym nadrukiem na zamówienie).",
      ]],
      ["§7. Reklamacje (rękojmia / niezgodność towaru z umową)", [
        "Sprzedawca odpowiada za zgodność towaru z umową na zasadach określonych w ustawie o prawach konsumenta.",
        `Reklamacje należy składać na adres e-mail ${EMAIL}. Reklamacja zostanie rozpatrzona w terminie 14 dni.`,
      ]],
      ["§8. Dane osobowe", [
        "Administratorem danych osobowych jest Sprzedawca. Szczegóły przetwarzania opisano w Polityce prywatności.",
      ]],
      ["§9. Postanowienia końcowe", [
        "W sprawach nieuregulowanych stosuje się przepisy prawa polskiego, w szczególności Kodeksu cywilnego oraz ustawy o prawach konsumenta.",
        "Konsument może skorzystać z pozasądowych sposobów rozpatrywania reklamacji i dochodzenia roszczeń, w tym platformy ODR: https://ec.europa.eu/consumers/odr.",
      ]],
    ],
  },
  "polityka-prywatnosci": {
    title: "Polityka prywatności (RODO)",
    body: [
      ["1. Administrator danych", [
        `Administratorem danych osobowych jest ${COMPANY}. Kontakt: ${EMAIL}.`,
      ]],
      ["2. Zakres i cel przetwarzania", [
        "Dane (imię, nazwisko, adres, e-mail, telefon, dane do faktury) przetwarzane są w celu realizacji zamówienia i zawartej umowy sprzedaży (art. 6 ust. 1 lit. b RODO), wystawienia dokumentów księgowych (lit. c) oraz obsługi reklamacji.",
      ]],
      ["3. Odbiorcy danych", [
        "Dane mogą być przekazywane podmiotom realizującym płatności (PayU S.A.), firmom kurierskim/InPost oraz dostawcom usług IT — wyłącznie w zakresie niezbędnym do realizacji zamówienia.",
      ]],
      ["4. Okres przechowywania", [
        "Dane przechowywane są przez okres niezbędny do realizacji umowy oraz przez okres wymagany przepisami prawa (m.in. podatkowymi).",
      ]],
      ["5. Prawa osoby, której dane dotyczą", [
        "Przysługuje Ci prawo dostępu do danych, ich sprostowania, usunięcia, ograniczenia przetwarzania, przenoszenia oraz wniesienia sprzeciwu, a także prawo wniesienia skargi do Prezesa UODO.",
      ]],
      ["6. Pliki cookies", [
        "Sklep może wykorzystywać pliki cookies niezbędne do działania koszyka i realizacji zamówienia.",
      ]],
    ],
  },
  odstapienie: {
    title: "Prawo odstąpienia od umowy",
    body: [
      ["Termin i zasady", [
        "Konsument może odstąpić od umowy w terminie 14 dni od dnia objęcia towaru w posiadanie, bez podawania przyczyny.",
        `Aby skorzystać z prawa odstąpienia, należy poinformować Sprzedawcę (${COMPANY}, e-mail ${EMAIL}) o decyzji w drodze jednoznacznego oświadczenia.`,
        "Do zachowania terminu wystarczy wysłanie oświadczenia przed jego upływem.",
      ]],
      ["Skutki odstąpienia", [
        "Sprzedawca zwraca wszystkie otrzymane płatności, w tym koszty dostawy (z wyjątkiem dodatkowych kosztów wynikających z wyboru droższego sposobu dostawy niż najtańszy oferowany), niezwłocznie, nie później niż w terminie 14 dni.",
        "Towar należy odesłać niezwłocznie, nie później niż 14 dni od odstąpienia. Bezpośrednie koszty zwrotu towaru ponosi Konsument.",
      ]],
      ["Wyłączenia", [
        "Prawo odstąpienia nie przysługuje m.in. w odniesieniu do towarów wykonanych według specyfikacji Konsumenta lub wyraźnie zindywidualizowanych (np. odzież z indywidualnym nadrukiem na zamówienie).",
      ]],
      ["Wzór formularza odstąpienia", [
        `Adresat: ${COMPANY}, e-mail: ${EMAIL}`,
        "Ja/My niniejszym informuję/informujemy o moim/naszym odstąpieniu od umowy sprzedaży następujących rzeczy: ____________",
        "Data zawarcia umowy / odbioru: ____________",
        "Imię i nazwisko konsumenta: ____________",
        "Adres konsumenta: ____________",
        "Data: ____________   Podpis (jeżeli formularz jest przesyłany w wersji papierowej): ____________",
      ]],
    ],
  },
};

export default function Legal({ doc }) {
  const d = DOCS[doc];
  if (!d) return <ShopLayout><div className="mx-auto max-w-3xl px-4 py-20 text-neutral-400">Dokument nie znaleziony.</div></ShopLayout>;
  return (
    <ShopLayout>
      <div className="mx-auto max-w-3xl px-4 py-12" data-testid={`legal-${doc}`}>
        <h1 className="font-display text-3xl font-extrabold uppercase tracking-tight mb-8">{d.title}</h1>
        <p className="mb-8 rounded-lg border border-amber-400/30 bg-amber-400/5 p-3 text-xs text-amber-200/80">Dokument ma charakter informacyjny i stanowi wzór dostosowany do danych Sprzedawcy. Zalecane jest potwierdzenie treści przez radcę prawnego przed publikacją.</p>
        <div className="space-y-8">
          {d.body.map(([h, paras]) => (
            <section key={h}>
              <h2 className="text-lg font-bold text-amber-400 mb-2">{h}</h2>
              <ul className="space-y-2 text-neutral-300 leading-relaxed text-sm">
                {paras.map((p, i) => <li key={i}>{p}</li>)}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </ShopLayout>
  );
}
